import { setBodyOverflow } from '../../helpers/utils.js';

export default function () {
    return {
        scrollLimiter: 300,
        isDisabledSticky: false,
        scrollAtTop: false,
        navElements: {
            account: 'account',
            cart: 'cart',
            menu: 'menu',
            search: 'search'
        },
        activeMobileNavElement: '',
        hideMobileNav: false,

        init() {
            this.setHeaderContainerHeight();
            this.setupWatchers();
            this.setupListeners();
        },

        setupWatchers() {
            this.$watch('$store.mq.minWidth', () => {
                this.activeMobileNavElement = '';
                this.scrollAtTop = false;
                this.setHeaderContainerHeight();
            });

            this.$watch('activeMobileNavElement', () => {
                if (!this.$store.mq.isMobile()) return;

                setBodyOverflow(!!this.activeMobileNavElement);
            });

            this.$watch('scrollAtTop', () => {
                if (!this.scrollAtTop) this.setHeaderContainerHeight();
            });

            this.handleScroll();
        },

        setupListeners() {
            window.addEventListener('resize', () => {
                this.setHeaderContainerHeight();
            });
        },

        handleScroll() {
            if (this.$store.mq.isMobile()) return;

            this.scrollAtTop = window.pageYOffset > this.scrollLimiter;
        },

        setActiveElement(elementName) {
            this.activeMobileNavElement === elementName
                ? (this.activeMobileNavElement = '')
                : (this.activeMobileNavElement = elementName);
        },

        setHeaderContainerHeight() {
            document.querySelector(
                'header'
            ).style.height = `${this.$el.offsetHeight}px`;
        }
    };
}
